const unsupported: string = "Unsupported";
const malicious: string = "Malicious";
const extremeRisk: string = "Extreme Risk";
const highRisk: string = "High Risk";
const mediumRisk: string = "Medium Risk";
const lowRisk: string = "Low Risk";
const noRisk: string = "No Risk";
const encrypted: string = "Encrypted File";

export const summaryTitlesForVerdicts: { [verdict: string]: string } = {
  [noRisk]: "This is a known clean file",
  [lowRisk]:
    "Low risk! The risk level is within the usual range of regular files and applications.",
  [mediumRisk]:
    "Medium risk! The risk level is above the usual range of regular files and applications.  ",
  [highRisk]:
    "High risk! The risk level of the file suggests a dangerous or malicious file.",
  [extremeRisk]: "Potentially malicious activity detected",
  [malicious]: "Critical risk! Malware detected.",
  [unsupported]:
    "Unsupported file type! Currently there is limited support for analysis of this file type. No deep file analysis is available.",
  [encrypted]:
    "Encrypted file! The file is encrypted. No scan or analysis could be performed. The risk level of the file is unknown.",
};

export const supportedTypes = [
  "7Z",
  "8BY2",
  "8BY3",
  "ACE",
  "AIF",
  "ALZ",
  "AMI",
  "APP",
  "AR",
  "ARJ",
  "AUTOIT",
  "BASE64",
  "BAT",
  "BMP",
  "BINXML",
  "BOOT",
  "BZ2",
  "CAB",
  "CDR",
  "CHM",
  "COM",
  "CRX",
  "CRTF",
  "CPIO",
  "DBS",
  "DEX",
  "DFL",
  "DMG",
  "DOOM",
  "DUMP",
  "E32",
  "E64",
  "EBCDIC",
  "EGG",
  "EMF",
  "ENC",
  "EXE",
  "FAT_MACHO",
  "FDBS",
  "GIF",
  "GZIP",
  "HA",
  "HDBS",
  "HFS",
  "HLP",
  "HQX",
  "HTA",
  "HQX",
  "INI",
  "INNO",
  "IS",
  "ISO",
  "ICR",
  "INF",
  "IMATE",
  "JET",
  "JAVA",
  "JOB",
  "JPG",
  "LZIP",
  "LZMA",
  "LZH",
  "LNK",
  "LINEAR",
  "MACHO",
  "MACBIN",
  "MACHYPER",
  "MACPEF",
  "MACRSRC",
  "MBR",
  "MF",
  "MIME",
  "MSLZ",
  "MSO",
  "NSIS",
  "OBJ",
  "OLE",
  "OLESTREAM",
  "OS2_LE",
  "OS2_LX",
  "PALM",
  "PDF",
  "PIF",
  "PNG",
  "PHP",
  "RAR",
  "REG",
  "RIFF",
  "RISI",
  "RTF",
  "RPM",
  "SH",
  "SIM",
  "SIS",
  "SLK",
  "SWF",
  "SCRIPT",
  "STREAM",
  "SUB",
  "SUHD",
  "SYMBIAN",
  "SYS",
  "SUF",
  "TAR",
  "TNEF",
  "TAZ",
  "TELEDISK",
  "TEMP",
  "TEXT",
  "TIFF",
  "UU",
  "UNICODE",
  "UNICODE4",
  "UNICODE4B",
  "UNICODEB",
  "UTF_8",
  "VBA",
  "VHD",
  "WASM",
  "VMWR",
  "WIN_64",
  "WIN_CE",
  "WIN_NE",
  "WIN_PE",
  "WISE",
  "WBT",
  "WMF",
  "WKS",
  "WORD2",
  "WORD6",
  "WPD",
  "XLSB",
  "XX",
  "XML",
  "XOR",
  "XZ",
  "YNC",
  "ZIP",
  "ZOO",
  "APK",
  "HTML",
  "WORD",
  "W97",
  "X97",
  "PP97",
  "XF",
];

export function getVerdictByRating(rating: number): string {
  switch (true) {
    case rating <= 0:
      return noRisk;
    case rating >= 0 && rating < 25:
      return lowRisk;
    case rating >= 25 && rating < 50:
      return mediumRisk;
    case rating >= 50 && rating < 75:
      return highRisk;
    case rating >= 75 && rating <= 100:
      return malicious;
    default:
      return unsupported;
  }
}

export function getVerdictbyFlag(ratingFlag: string): string {
  switch (true) {
    case ratingFlag === "CLEAN FILE":
      return noRisk;
    case ratingFlag === "LOW RISK":
      return lowRisk;
    case ratingFlag === "MEDIUM RISK":
      return mediumRisk;
    case ratingFlag === "HIGH RISK":
      return highRisk;
    case ratingFlag === "CRITICAL RISK":
      return malicious;
    case ratingFlag === "ENCRYPTED FILE":
      return encrypted;
    default:
      return unsupported;
  }
}

// TODO: Make a more granular array of colors
export function getSummaryColorByRating(rating: number): string {
  if (rating === undefined) {
    return "gray";
  }
  switch (true) {
    case rating <= 0:
      return "green";
    case rating >= 0 && rating <= 20:
      return "#364B97";
    case rating > 20 && rating <= 70:
      return "#A8740E";
    default:
      return "#EE391E";
  }
}

export const categoryTitles: { [category: string]: string } = {
  Category: "Description",
  Detected: "Varist AV Detection",
  Execute: "Execution or process-related activity",
  Autoex: "Automatic execution",
  Download: "Downloading activity",
  Internet: "Internet activity",
  Network: "Network activity",
  Install: "Installation activity",
  External: "Use of external objects",
  ScriptShell: "Use of scripts or shell applications",
  Filesystem: "File system activity",
  Evasion: "Evasive activity",
  Privilege: "Privilege-related activity",
  Denial: "Denial-of-service or data wiping",
  Registry: "Registry use",
  Enumerate: "Process enumeration",
  Inject: "Code injection",
  Clipboard: "Clipboard access",
  Intercept: "Interception/hooking",
  Mutex: "Synchronization",
  Debug: "Debug usage/detection",
  Service: "Service use/changes",
  Socket: "Socket-level access",
  Device: "Device access/changes",
  Thread: "Thread usage",
  Cookies: "Cookie usage",
  Virtual: "Memory manipulation",
  Resources: "Resource access",
  Environment: "Environment variable use",
  Info: "Info",
};

export const categoryDescriptions: { [category: string]: string } = {
  Category: "Description",
  AudioVisual: "Indicates camera or recording activity",
  Autoex:
    "Indicates automatic, possibly unwanted execution of code - in particular code that may get executed without the knowledge or permission of the user. A typical example would be an MS Office document containing macros which automatically get run when the document is opened",
  Browser: "The use of cookies, bookmarks or browser history",
  Crypto: "Indicates the use of cryptography/encryption",
  Data: "Indicates the acessing or transfer of some data",
  Debug: "The use or detection of debugging",
  Deception: "Deception or social engineering",
  Denial:
    "Indicates behavior suggesting denial-of-service activity (including shutdown, locking or data erasure)",
  Detected:
    "Indicates detection of something which would be reported by our AV scanner",
  Download:
    "Indicates downloading activity, or at least that downloading functionality is present",
  Enumerate: "Process enumeration",
  Environment: "Indicates the use of environment variables",
  Evasion:
    "Evasive activity. Behaviour suggesting an attempt to hide malicious code or avoid detection",
  Execute: "Indicates execution of another process",
  External: "Indicates use or access of external objects",
  Filemod:
    "File modification. Likely to indicate some run-time compression or other non-malicious additional code",
  Filesystem: "Indicates file system activity",
  Info: "Informational item which may be of interest",
  Inject: "Possible code injection",
  Install: "Indicates file installation activity",
  Intercept: "The use of hooking or interception of system activity",
  Internet: "Indicates (local) network-related activity",
  LowLevel: "Indicates low-level manipulation of threads or processes",
  Memory: "Indicates memory manipulation",
  Meta: "Various metadata and other bits of information which are primarily listed for informative purposes",
  Mutex: "Indicates the use of synchronization",
  Network: "Network activity",
  Other: "Other notable activity",
  Phone: "Telephone or SMS-related activity",
  Privilege:
    "Privilege escalation. Indicates behavior suggesting an attempt to modify or obtain special privileges",
  Registry:
    "Indicates registry use. Whether this is malicious depends entirely on the the registry entries being used/modified",
  Resources: "Indicates the use of the resource section",
  Suspicious: "Suspicious activity",
  System:
    "Indicates access to system information or the use or manipulation of services, threads or other system resources",
  Virtual: "Memory manipulation",
};

export const fileTypes: { [Type: string]: string } = {
  "7Z": "7-Zip Compressed File",
  "8BY2": "Adobe Photoshop 2.0 Plug-in",
  "8BY3": "Adobe Photoshop 3.0 Plug-in",
  ACE: "WinAce Compressed File",
  AIF: "Audio Interchange File Format",
  ALZ: "ALZip Compressed File",
  AMI: "Amiga Disk File",
  APP: "Application File",
  AR: "Unix Archive File",
  ARJ: "ARJ Compressed File",
  AUTOIT: "AutoIt Script File",
  BASE64: "Base64 Encoded File",
  BAT: "Batch File",
  BMP: "Bitmap Image File",
  BINXML: "Binary XML File",
  BOOT: "Boot Sector File",
  BZ2: "Bzip2 Compressed File",
  CAB: "Windows Cabinet File",
  CDR: "CorelDRAW Image File",
  CHM: "Compiled HTML Help File",
  COM: "Command File",
  CRX: "Chrome Extension",
  CRTF: "Compiled Rich Text Format",
  CPIO: "CPIO Archive",
  DBS: "Database File",
  DEX: "Dalvik Executable",
  DFL: "Define Files",
  DMG: "Apple Disk Image",
  DOOM: "DOOM Game File",
  DUMP: "Dump File",
  E32: "E32 Executable",
  E64: "E64 Executable",
  EBCDIC: "Extended Binary Coded Decimal Interchange Code",
  EGG: "EGG Compressed File",
  EMF: "Enhanced Metafile",
  ENC: "Encoded File",
  EXE: "Executable File",
  FAT_MACHO: "FAT Mach-O File",
  FDBS: "Fiction Book Editor",
  GIF: "Graphical Interchange Format File",
  GZIP: "GNU Zip Compressed File",
  HA: "HA Compressed File",
  HDBS: "Hyper Database File",
  HFS: "Hierarchical File System",
  HLP: "Help File",
  HQX: "BinHex 4.0 Encoded File",
  HTA: "HTML Application",
  INI: "Initialization File",
  INNO: "Inno Setup Script",
  IS: "InstallShield Script",
  ISO: "ISO Disc Image",
  ICR: "Image Character Recognition",
  INF: "Setup Information File",
  IMATE: "I-MATE Compressed File",
  JET: "JET Database",
  JAVA: "Java Source Code File",
  JOB: "Windows Task Scheduler Job File",
  JPG: "JPEG Image",
  LZIP: "Lzip Compressed File",
  LZMA: "LZMA Compressed File",
  LZH: "LZH Compressed File",
  LNK: "Windows Shortcut",
  LINEAR: "Linear Executable File",
  MACHO: "Mach-O Executable",
  MACBIN: "MacBinary Encoded File",
  MACHYPER: "HyperCard Stack File",
  MACPEF: "PowerPC Executable Format",
  MACRSRC: "Macintosh Resource File",
  MBR: "Master Boot Record",
  MF: "Manifest File",
  MIME: "Multipurpose Internet Mail Extensions File",
  ML: "Markup Language",
  MSLZ: "Microsoft LZ Compressed File",
  MSO: "Microsoft Office File",
  NSIS: "Nullsoft Scriptable Install System File",
  OBJ: "Relocatable Object Code",
  OLE: "Object Linking and Embedding File",
  OLESTREAM: "OLE Structured Storage File",
  OS2_LE: "OS/2 Linear Executable",
  OS2_LX: "OS/2 Linear Executable",
  PALM: "Palm OS File",
  PDF: "Portable Document Format",
  PIF: "Program Information File",
  PNG: "Portable Network Graphic",
  PHP: "PHP Source Code File",
  RAR: "WinRAR Compressed Archive",
  REG: "Registry File",
  RIFF: "Resource Interchange File Format",
  RISI: "Remote Installation Services File",
  RTF: "Rich Text Format File",
  RPM: "Red Hat Package Manager File",
  SH: "Shell Script",
  SIM: "Simulation File",
  SIS: "Symbian Installation Source",
  SLK: "Symbolic Link File",
  SWF: "Shockwave Flash File",
  SCRIPT: "Script File",
  SUB: "Subtitle File",
  SUHD: "Super HD Video File",
  SYMBIAN: "Symbian OS File",
  SYS: "System File",
  SUF: "Suf Encoded File",
  TAR: "Tape Archive File",
  TNEF: "Transport Neutral Encapsulation Format",
  TAZ: "Tar Zipped File",
  TELEDISK: "TeleDisk Archive",
  TEMP: "Temporary File",
  TEXT: "Text File",
  TIFF: "Tagged Image File Format",
  UU: "Uuencoded File",
  UNICODE: "Unicode Text File",
  UNICODE4: "Unicode Text File 4.0",
  UNICODE4B: "Unicode Text File 4.0 Big Endian",
  UNICODEB: "Unicode Text File Big Endian",
  UTF_8: "UTF-8 Encoded Text File",
  VBA: "Visual Basic for Applications File",
  VHD: "Virtual Hard Disk",
  WASM: "WebAssembly File",
  VMWR: "VMware File",
  WIN_64: "Windows 64-bit Executable",
  WIN_CE: "Windows CE File",
  WIN_NE: "Windows New Executable",
  WIN_PE: "Windows Portable Executable",
  WISE: "Wise Installation Script",
  WBT: "WinBatch Script",
  WMF: "Windows Metafile",
  WKS: "Worksheet File",
  WORD2: "Microsoft Word 2.0 Document",
  WORD6: "Microsoft Word 6.0 Document",
  WPD: "WordPerfect Document",
  XLSB: "Excel Binary Workbook",
  XX: "XXEncoded File",
  XML: "Extensible Markup Language",
  XOR: "Exclusive OR Encoded File",
  XZ: "XZ Compressed File",
  YNC: "YEnc Encoded File",
  ZIP: "ZIP Archive",
  ZOO: "ZOO Compressed Archive",
  APK: "Android Package",
  HTML: "Hypertext Markup Language File",
  WORD: "Microsoft Word Document",
  W97: "Microsoft Word 97 Document",
  X97: "Microsoft Excel 97 Spreadsheet",
  PP97: "Microsoft PowerPoint 97 Presentation",
  XF: "Extended File",
};
